import { Grid } from '@mui/joy'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormValues } from '~/entities/russia/Driver'
import { countries } from '~/shared/config/constants'
import { getPassportMaskByCountry } from '~/shared/config/countryConfig'
import { getObject } from '~/shared/lib/utils'
import {
  AutocompleteInput,
  DatePickerInput,
  MaskInput,
  TextInput,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type PassportProps = {
  disabled?: boolean
  skeletonShow?: boolean
  form: UseFormReturn<FormValues>
}

export function Passport({ disabled, skeletonShow, form }: PassportProps) {
  const { t } = useTranslation()
  const citizenshipForm = form.watch('citizenship')
  const citizenshipCode = getObject(citizenshipForm)?.id

  return (
    <Container data-testid='passport-form-container'>
      <ContainerTitle>{t('passport')}</ContainerTitle>

      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <AutocompleteInput
            label='form.citizenship'
            placeholder='form.choose citizenship'
            name='citizenship'
            options={countries}
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <MaskInput
            label='form.series and number'
            placeholder='form.enter series and number'
            name='passportNumber'
            readOnly={disabled}
            skeletonShow={skeletonShow}
            mask={getPassportMaskByCountry(citizenshipCode)}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.date of birth'
            placeholder='form.enter date of birth'
            name='birthDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.date of issue'
            placeholder='form.enter date of issue'
            name='passportIssueDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.expiry date'
            placeholder='form.enter expiry date'
            name='data.passportExpirationDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.registration address'
            placeholder='form.enter registration address'
            name='registrationAddress'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.place of birth'
            placeholder='form.enter place of birth'
            name='data.birthPlace'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.division code'
            placeholder='form.enter division code'
            name='divisionCode'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.issued by'
            placeholder='form.enter issued by'
            name='passportIssued'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
